import TableBlock from './tableBlock.component';

export default TableBlock;
